// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

window.$ = jQuery;

import ParagraphTypeAccordion from '../_modules/paragraph--type--accordion/paragraph--type--accordion';
import Work from '../_modules/work/work';
import Homepage from '../_modules/homepage/homepage';
import HeaderMenu from '../_modules/header/header';
import ParagraphTypePartnerCarousel from '../_modules/paragraph--type--partner-carousel/paragraph--type--partner-carousel';
import ParagraphTypeSlick from '../_modules/paragraph--type--slick/paragraph--type--slick';
import PageNodeTypeWork from '../_modules/page-node-type-work/page-node-type-work';
import Newsletter from '../_modules/newsletter/newsletter';

$(() => {
  new ParagraphTypeAccordion();
  new Work();
  new Homepage();
  new HeaderMenu();
  new ParagraphTypePartnerCarousel();
  new ParagraphTypeSlick();
  new PageNodeTypeWork();
  new Newsletter();



  $("body").on("click", ".animated-menu .menu-links .left-col a", function (e) {
    $("body").removeClass("show-menu");
  })


  animateHomepage();

  function animateHomepage() {
    let heroBanner = $(".homepage-hero");

    if (heroBanner.length < 1) {
      return;
    }

    let videoFrame = heroBanner.find("iframe")[0];

    let player = new Vimeo.Player(videoFrame);

    setTimeout(function () {
      $(".region-header-top").addClass("show");
    }, 600);

    setTimeout(function () {
      heroBanner.find(".homepage-hero_title").addClass("show");
    }, 1200);

    player.on('timeupdate', function (data) {
      if (data.seconds > 0) {
        if ($("body").hasClass("loaded")) return;
        $("body").addClass("loaded");

        $(videoFrame).addClass("show");
      }
    });
  }


  $(window).on("load", function () {
    var waypoint = new Waypoint({
      element: document.body,
      handler: function (direction) {
        if (direction === 'down') {
          document.querySelector('.header-top').classList.add('scrolled');
        } else {
          document.querySelector('.header-top').classList.remove('scrolled');
          document.querySelector('.header-top').classList.add('no-blend');
          
          setTimeout(function() {
            document.querySelector('.header-top').classList.remove('no-blend');
          }, 300);
        }
      },
      offset: -300
    });
  });


});
